import { FC } from 'react'

import { colors } from '../../theme'
import Collapsable from '../Collapsable'
import { RecipesFiltersProps } from '../RecipesFilters'
import { RecipeCardListProps } from '../RecipeCardList'
import { ECollapsable } from '../Collapsable/types'

import * as SC from './styled'

export type RecipesListSectionProps = {
  className?: string
  recipesFiltersProps?: RecipesFiltersProps
  recipeCardListProps?: RecipeCardListProps
  rounded?: boolean
  resultsRef?: any
}

const RecipesListSection: FC<RecipesListSectionProps> = (props) => {
  const {
    className,
    recipesFiltersProps,
    recipeCardListProps,
    rounded,
    resultsRef,
  } = props

  return (
    <Collapsable
      className={className}
      isCollapsable={ECollapsable.NONE}
      backgroundColor={colors.pureWhite}
      isOpenOnInit
      rounded={rounded}
    >
      <SC.Inner>
        <SC.Anchor ref={resultsRef} />
        {recipesFiltersProps && <SC.Filters {...recipesFiltersProps} />}
        {recipeCardListProps && <SC.CardList {...recipeCardListProps} />}
      </SC.Inner>
    </Collapsable>
  )
}

export default RecipesListSection
